import {
  GetBulkChangeItemsResponse,
  GetPartsBulkChangeItemsResponse,
  GetSupplierBulkChangeItemsResponse
} from '@/main/models/response';
import {
  IPartReturn,
  IPartReturnWithSupplier,
  IProcurementReturn,
  ISupplierReturn
} from './types';
import { IFormValues } from './modalBulkReturnClaim';

function agroupPartsBySupplier(
  procurements: IProcurementReturn[]
): ISupplierReturn[] {
  const suppliers = procurements.flatMap(
    procurement => procurement.supplierPartsUpdateables
  );

  const agroupedSupplier = suppliers.reduce((acc, supplier) => {
    const supplierFound = acc.find(
      accSupplier => accSupplier.guidSupplier === supplier.guidSupplier
    );
    if (supplierFound) {
      supplierFound.updateableParts = [
        ...supplierFound.updateableParts,
        ...supplier.updateableParts
      ];
    } else {
      acc.push(supplier);
    }
    return acc;
  }, [] as ISupplierReturn[]);
  return agroupedSupplier;
}

function mapBackendToFrontendReturnClaim(
  response: GetBulkChangeItemsResponse
): IProcurementReturn {
  const formatSupplier = (
    supplier: GetSupplierBulkChangeItemsResponse
  ): ISupplierReturn => {
    const formatPart = (
      part: GetPartsBulkChangeItemsResponse
    ): IPartReturn => ({
      ...part,
      guidProcurement: response.guidProcurement,
      guidProcurementSupplierItem: part.guidProcurementSupplierItem,
      guidProcurementSupplier: supplier.guidProcurementSupplier,
      deliveryBySupplier: Boolean(supplier.deliveryBySupplier),
      isSelected: true
    });

    return {
      ...supplier,
      reason: null,
      reasonDescription: '',
      isSelectedAll: true,
      guidProcurement: response.guidProcurement,
      updateableParts: supplier.updateableParts.map(formatPart)
    };
  };

  return {
    ...response,
    isSelectedAll: true,
    supplierPartsUpdateables: response.supplierPartsUpdateables.map(
      formatSupplier
    )
  };
}

export function backendToFrontendReturnClaim(
  response: GetBulkChangeItemsResponse[]
): ISupplierReturn[] {
  const formattedeProcurement = response.map(mapBackendToFrontendReturnClaim);
  const agroupedSupplier = agroupPartsBySupplier(formattedeProcurement);

  return agroupedSupplier;
}

export const getNameFormPart = (
  name: keyof IPartReturn,
  indexSupplier: number,
  indexPart: number
) => `suppliers.${indexSupplier}.updateableParts.${indexPart}.${name}` as const;

export const getNameFormSupplier = (
  name: keyof ISupplierReturn,
  indexSupplier: number
) => `suppliers.${indexSupplier}.${name}` as const;

export const getAllPartsForm = (data: IFormValues): IPartReturn[] =>
  data.suppliers.flatMap(supplier =>
    supplier.updateableParts.filter(i => i.isSelected)
  );
export const getAllPartsFormWithSupplier = (
  data: IFormValues
): IPartReturnWithSupplier[] => {
  const allParts = data.suppliers.flatMap((supplier, indexSupplier) =>
    supplier.updateableParts.map((part, indexPart) => ({
      ...part,
      supplier,
      indexSupplier,
      indexPart
    }))
  );
  return allParts.filter(i => i.isSelected);
};

